const COMMUNITY_ICON_BASE = `${(typeof window !== 'undefined' && window.__BASE_PATH__) || ''}/assets`;

export const getCommunityIconPath = (platform = '') => {
  const normalizedPlatform = String(platform).toLowerCase();

  if (normalizedPlatform === 'facebook') return `${COMMUNITY_ICON_BASE}/ic_facebook.svg`;
  if (normalizedPlatform === 'telegram') return `${COMMUNITY_ICON_BASE}/ic_telegram.svg`;
  if (normalizedPlatform === 'tiktok') return `${COMMUNITY_ICON_BASE}/ic_tiktok.svg`;
  if (normalizedPlatform === 'youtube') return `${COMMUNITY_ICON_BASE}/ic_youtube.svg`;

  return `${COMMUNITY_ICON_BASE}/ic_community.svg`;
};
